export enum ButtonVariant {
  default = 'default',
  primary = 'primary',
  secondary = 'secondary',
  tertiary = 'tertiary',
  darkGray = 'darkGray',
}

export enum ButtonSize {
  small = 'small',
  medium = 'medium',
  large = 'large',
}
